import axios from './axios';
import { store } from '../index';
import { Cookies } from 'react-cookie';
import { getGlobalShowError, useError } from '../helpers/ErrorContext';
import { humanErrorText } from '../helpers/errorText';
import alert from '../helpers/alert';
const cookies = new Cookies();

const defaultHeaders = async (accessToken) => {
  return {
    'Content-Type': 'application/json',
    // Authorization: `Bearer ${store?.getState()?.user?.token}`,
    Authorization: `Bearer ${cookies.get('access_token')}`,
  };
};

// ÐÑÐ¸Ð±ÐºÐ¸ ÑÑÐ¸Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð² Ð¾Ð±ÑÐ°Ð±Ð°ÑÑÐ²Ð°ÑÑÑÑ Ð½Ð° Ð¼ÐµÑÑÐµ Ð¸ Ð½Ðµ ÑÐ°ÑÐ°Ð»ÑÐ½Ñ â Ð³Ð»Ð¾Ð±Ð°Ð»ÑÐ½ÑÑ
// Ð¼Ð¾Ð´Ð°Ð»ÐºÑ Ñ Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹ Ð¿Ð¾ Ð½Ð¸Ð¼ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼.
// Ð¡Ð²ÐµÑÑÐµÐ¼ Ð¿Ð¾ ÐºÐ¾Ð½ÑÑ Ð¿ÑÑÐ¸, Ð° Ð½Ðµ Ð¿Ð¾ Ð²ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ: Ð¸Ð½Ð°ÑÐµ '/createComplectation'
// Ð³Ð»ÑÑÐ¸Ð» Ð±Ñ Ð¸ '/createComplectationOptions'.
const IGNORE_URLS = [
  '/getDcRequisites',
  // ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð¿Ð¾ VIN Ð´ÑÑÐ³Ð°ÐµÑÑÑ Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐµ Ð¿Ð¾Ð»-ÑÐµÐºÑÐ½Ð´Ñ Ð²Ð²Ð¾Ð´Ð°: ÑÐ±Ð¾Ð¹ ÑÑÑ Ð½Ðµ ÑÐ°ÑÐ°Ð»ÐµÐ½, ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿ÑÐ¾ÑÑÐ¾ Ð¿ÑÑÑ.
  '/findByVin',
  // ÐÐ±ÑÑÐµÐ½Ð¸Ðµ Ð½Ð¾Ð²Ð¸ÑÐºÐ°: ÐµÑÐ»Ð¸ ÑÐµÑÐ²ÐµÑ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð», ÐºÐ°Ð±Ð¸Ð½ÐµÑ Ð±ÐµÑÑÑ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¸Ð·
  // Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð¸ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð´Ð°Ð»ÑÑÐµ â Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ ÑÑÑ Ð½Ð¸ Ðº ÑÐµÐ¼Ñ.
  '/crm/onboarding',
  '/crm/onboarding/reset',
  // ÐÑÐ¾Ð²ÐµÑÐºÐ° ÐÐÐ: ÐµÑÐ»Ð¸ ÑÐµÑÐ²Ð¸Ñ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð», Ð²ÑÐ·ÑÐ²Ð°ÑÑÐ¸Ð¹ ÑÐºÑÐ°Ð½ ÑÐ°Ð¼ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ
  // Ð¿Ð¾Ð½ÑÑÐ½ÑÐ¹ ÑÐµÐºÑÑ (BMG_UNAVAILABLE_MESSAGE), Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° ÑÐ¾ ÑÑÐµÐºÐ¾Ð¼ Ð½Ðµ Ð½ÑÐ¶Ð½Ð°.
  '/bmg/phoneBelongsIinValidate',
  // Ð¡Ð¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸, Ð·Ð°Ð²Ð¾Ð´Ð¸Ð¼ÑÐµ Ð¿ÑÑÐ¼Ð¾ Ð² ÑÐµÐ»ÐµÐºÑÐµ (Ð±/Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ):
  // Â«Ð¼Ð°ÑÐºÐ° ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑÂ» Ð¸ Ñ.Ð¿. Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾ÑÑÐ¾Ð¼ ÑÑÐ´Ð¾Ð¼ Ñ Ð¿Ð¾Ð»ÐµÐ¼.
  '/createMark',
  '/createModel',
  '/createComplectation',
  '/ensureContainer',
  // Ð¡Ð¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸ Ð¼Ð°ÑÐ¾Ðº Ð¸ Ð¼Ð¾Ð´ÐµÐ»ÐµÐ¹: Ð¿ÑÐ¸ÑÐ¸Ð½Ñ Ð¾ÑÐºÐ°Ð·Ð° (Â«Ñ Ð¼Ð°ÑÐºÐ¸ ÐµÑÑÑ Ð¼Ð¾Ð´ÐµÐ»Ð¸Â»,
  // Â«Ðº Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â») Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾ÑÑÐ¾Ð¼ Ð½Ð° ÑÐ°Ð¼Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ.
  '/deleteMark',
  '/deleteModel',
  // ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ÑÐ°Ð±Ð»Ð¸ÑÑ Ð¾ÑÑÑÑÐ° Ð¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð²ÑÐ³ÑÑÐ·Ð¾Ðº ÑÑÐ¾ÑÐ¾Ð²: ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ Â«ÐÑÑÑÑÑÂ» ÑÐ°Ð¼Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ Ð¿ÑÐ¸ÑÐ¸Ð½Ñ
  // ÑÑÐ´Ð¾Ð¼ Ñ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹, Ð° ÑÑÐ°ÑÑÑ Ð¾Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÑÑÑ ÐºÐ°Ð¶Ð´ÑÐµ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐºÑÐ½Ð´ â Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐ±Ð¾Ð¹ Ð±ÑÐ»Ð° Ð±Ñ Ð»Ð¸ÑÐ½ÐµÐ¹.
  '/crm/reports/app-refresh',
  '/crm/reports/app-installs/import',
];

export default class api {
  static onError(error) {
    console.log('[API ERROR]:', error);

    const showError = getGlobalShowError();

    if (error?.response?.data?.error === 'ÐÐ¢Ð Ð½Ðµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½') {
      return Promise.reject(error);
    }

    let message =
      error?.response?.data?.errorMessage ||
      error?.response?.data?.message ||
      error?.message;

    if (!message && error?.response?.data) {
      if (typeof error.response.data === 'string') {
        message = error.response.data;
      } else {
        message = JSON.stringify(error.response.data);
      }
    }

    if (!message) {
      message = 'ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°';
    }

    const details = error?.response?.data || error?.toJSON?.() || error;

    if (showError && !IGNORE_URLS.some((url) => error?.config?.url?.endsWith(url))) {
      // ÐÑÐ»Ð¸ Ð±ÑÐºÐµÐ½Ð´ Ð¾Ð±ÑÑÑÐ½Ð¸Ð» Ð¿ÑÐ¸ÑÐ¸Ð½Ñ Ð¿Ð¾-ÑÐµÐ»Ð¾Ð²ÐµÑÐµÑÐºÐ¸ â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐ¾ÑÑ Ñ ÑÑÐ¸Ð¼
      // ÑÐµÐºÑÑÐ¾Ð¼. ÐÐ¾Ð´Ð°Ð»ÐºÐ° ÑÐ¾ ÑÑÐµÐºÐ¾Ð¼ Ð½ÑÐ¶Ð½Ð° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾Ð³Ð´Ð°, ÐºÐ¾Ð³Ð´Ð° Ð¾Ð±ÑÑÑÐ½ÐµÐ½Ð¸Ñ Ð½ÐµÑ:
      // Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¾Ð½Ð° Ð²ÑÑ ÑÐ°Ð²Ð½Ð¾ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð´Ð°ÑÑ, Ð° ÑÐ°Ð±Ð¾ÑÑ Ð¿ÐµÑÐµÐºÑÑÐ²Ð°ÐµÑ.
      const humanText = humanErrorText(error?.response?.data);

      if (humanText) {
        alert.error(humanText);
      } else {
        showError({
          message,
          details,
          config: error.config,
        });
      }
    }

    return Promise.reject(error);
  }

  static async post(path, data, config = {}) {
    const headers = await defaultHeaders();
    return axios
      .post(`${path}`, data, { headers, ...config })
      .then((res) => {
        console.info('ðª² POST', path, data, res?.data);
        return res;
      })
      .catch(api.onError);
  }

  static async uploadFile(path, data, config = {}) {
    // const headers = await defaultHeaders();

    return axios
      .post(`${path}`, data, {
        // headers,
        ...config,
        'Content-Type': 'multipart/form-data',
      })
      .catch(api.onError);
  }

  static async put(path, data, config = {}) {
    const headers = await defaultHeaders();

    return axios.put(`${path}`, data, { headers, ...config }).catch(api.onError);
  }

  static async patch(path, data, config = {}) {
    const headers = await defaultHeaders();

    return axios.patch(`${path}`, data, { headers, ...config }).catch(api.onError);
  }

  static async delete(path, id) {
    const headers = await defaultHeaders();
    const url = [path, id].join('');

    return axios.delete(`${url}`, { headers }).catch(api.onError);
  }

  static async get(path, params = {}, config = {}) {
    const headers = await defaultHeaders();
    return axios
      .get(`${path}`, { headers, params, ...config })
      .then((res) => {
        console.info('ðª² GET', path, params, res?.data);
        return res;
      })
      .catch(api.onError);
  }
}
